import template from './objective_details_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class PerformanceObjectiveDetailsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class PerformanceObjectiveDetailsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new PerformanceObjectiveDetailsHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'PerformanceObjectiveDetailsHelp',
	dialog_class: PerformanceObjectiveDetailsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/objective_details_help',
	provider: 'ps'
};